<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 298.667 298.667"
    style="enable-background: new 0 0 298.667 298.667"
    xml:space="preserve"
  >
    <g>
      <g>
        <rect y="128" width="298.667" height="42.667" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AppMinusIcon',
};
</script>
